import PanelCard from './PanelCard';

export default PanelCard;